const temaLight = {
  corPrincipal: '#282a35',
  corSecundaria: '#949494',
  corDeFundo: '#fff',
  corDeFundoBotao: '#4476bf',
  corDaBorda: '#c1c1c1'
};

export default temaLight;
